var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C15.9853 18 18 15.9853 18 13.5C18 11.0147 15.9853 9 13.5 9C11.0147 9 9 11.0147 9 13.5C9 15.9853 11.0147 18 13.5 18Z",
    fill: "#FFF057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15C14.3284 15 15 14.3284 15 13.5C15 12.6716 14.3284 12 13.5 12C12.6716 12 12 12.6716 12 13.5C12 14.3284 12.6716 15 13.5 15Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7127 6.71312C21.4966 3.43033 17.7661 1.2541 13.5185 1.2541C6.75923 1.2541 1.25581 6.75 1.25581 13.5C1.25581 20.25 6.75923 25.7459 13.5185 25.7459C20.2777 25.7459 25.7811 20.25 25.7811 13.5C25.7811 12.3934 25.6334 11.2869 25.3379 10.291L25.8919 8.11475C26.6306 9.77459 27 11.582 27 13.5C27 20.9508 20.9425 27 13.4815 27C6.02052 27 0 20.9508 0 13.5C0 6.04918 6.05745 0 13.5185 0C17.8399 0 21.6443 2.02869 24.119 5.16393L23.7127 6.71312Z",
    fill: "#FFF057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.575 13.4453L20.9531 14.9125C20.6534 15.0914 20.2788 14.9841 20.0916 14.6978C19.9043 14.4115 20.0166 14.0179 20.3163 13.8748L22.7884 12.4791L25.785 1.45735C25.8599 1.13528 26.2345 0.920571 26.5341 1.02793C26.8712 1.0995 27.0585 1.45735 26.9836 1.77941L23.9122 13.0159C23.9871 12.9086 23.9496 13.3022 23.575 13.4453Z",
    fill: "#FFF057"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1704 23C8.56244 23 4 18.3593 4 12.6551C4 11.1396 4.31649 9.67829 4.93525 8.31465C5.05971 8.04337 5.3762 7.92401 5.6429 8.0506C5.90961 8.1772 6.02696 8.49912 5.9025 8.7704C5.34775 9.99298 5.06327 11.2987 5.06327 12.6551C5.06327 17.7625 9.14564 21.9149 14.1668 21.9149C15.2407 21.9149 16.2898 21.7268 17.2855 21.3578C17.5629 21.2566 17.8687 21.4012 17.9682 21.6834C18.0678 21.9655 17.9256 22.2766 17.6482 22.3779C16.5352 22.7902 15.3616 23 14.1633 23H14.1704Z",
    fill: "#FFF057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdIcon);
export default __webpack_public_path__ + "static/media/cd-icon.a84e77611acb43e0fb6017efce7c56a5.svg";
export { ForwardRef as ReactComponent };